import { useState, useEffect } from 'react';
import { getDomains } from '../services/firestore';

export function useDomains() {
  const [domains, setDomains] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const [error, setError] = useState(null);
  const [lastDoc, setLastDoc] = useState(null);
  const [hasMore, setHasMore] = useState(true);

  const fetchDomains = async (reset = false) => {
    try {
      if (reset) {
        setLoading(true);
        setLastDoc(null);
      }
      const { items: data, lastDoc: newLastDoc, hasMore: more } = await getDomains(50, reset ? null : null);
      setDomains(data);
      setLastDoc(newLastDoc);
      setHasMore(more);
      setError(null);
    } catch (err) {
      console.error('Error fetching domains:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const loadMore = async () => {
    if (!hasMore || loadingMore) return;

    try {
      setLoadingMore(true);
      const { items: data, lastDoc: newLastDoc, hasMore: more } = await getDomains(50, lastDoc);
      setDomains(prev => [...prev, ...data]);
      setLastDoc(newLastDoc);
      setHasMore(more);
    } catch (err) {
      console.error('Error loading more domains:', err);
    } finally {
      setLoadingMore(false);
    }
  };

  useEffect(() => {
    fetchDomains(true);
  }, []);

  return { domains, loading, loadingMore, error, refetch: () => fetchDomains(true), loadMore, hasMore };
}
